

<div class="flex w-full flex-row mt-5 mb-2">

    <div *ngIf="encounter" class="flex w-4">
        <p-floatLabel>
            <p-inputNumber id="harloweSavings"  [(ngModel)]="encounter.confirmedGain" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
            <label for="harloweSavings">Total Gain</label>
        </p-floatLabel>
    </div>

    <div *ngIf="encounter" class="flex w-4">
        <p-floatLabel>
            <p-inputNumber id="harloweSavings"  [(ngModel)]="encounter.savings" mode="currency" currency="USD" locale="en-US"  [disabled]="true" />
            <label for="harloweSavings">Total Savings</label>
        </p-floatLabel>
    </div>
    
    <div class="flex w-4 justify-content-end">
        <div class="flex flex-column">
            <p-button *ngIf="encounterScheduled" [disabled]="editingMedicalBill || editingNewBill" icon="pi pi-plus" text label="Add New Bill" (onClick)="createNewBill($event)" [disabled]="encounterLocked"/>
            <p-fileUpload 
                *ngIf="encounterScheduled" [disabled]="editingMedicalBill || editingNewBill"
                [disabled]="encounterLocked"
                mode="basic" 
                chooseLabel="Upload New Bill" 
                chooseIcon="pi pi-upload"
                accept="application/pdf" maxFileSize="10000000" 
                customUpload
                (uploadHandler)="createBillFromUpload($event)"
                [auto]="true"/>
        </div>


    </div>
</div>


<div *ngIf="!editingMedicalBill" class="flex flex-column">
    <p-panel *ngFor="let bill of medicalBills; index as i" styleClass="h-full w-full mt-2">
        <ng-template pTemplate="header">
            <div class="flex w-3 align-items-center">
                <h4>Medical Bill</h4>
                <i *ngIf="i == 0" class="pi pi-star-fill ml-2"></i>
            </div>

            <div *ngIf="bill" class="flex w-5 gap-2 flex-row">
                <span>{{bill.lines[0].procedure.category.categoryName}}</span>
                <span>{{bill.serviceBegin | date: 'shortDate'}}</span>
            </div>
            
            <div class="flex w-4 justify-content-end mr-3">
                <div class="flex flex-column justify-content-center">
                    <div *ngIf="bill && bill.medicalBillImage" class="flex p-2 justify-content-center">
                        <div class="flex flex-row align-items-center">
                            <p-menu appendTo="body" #billImageMenu [model]="generateBillImageMenuItems(bill)" popup />
                            <i class="cursor-pointer pi pi-file-pdf text-5xl" (click)="billImageMenu.toggle($event)"></i>
                        </div>
                    </div>
                    <div *ngIf="bill && !bill.medicalBillImage" class="flex p-2 justify-content-center">
                        <p-fileUpload mode="basic" 
                            chooseIcon="pi pi-upload" 
                            accept="application/pdf" maxFileSize="10000000" 
                            customUpload
                            (uploadHandler)="uploadBillImage($event,bill)"
                            [auto]="true"/>
                    </div>
                    <div>Bill Image</div>
                </div>
            </div>
            <div class="flex w-4 justify-content-end mr-3">
                <div class="flex flex-column justify-content-center">
                    <div *ngIf="bill && bill.medicalBillProviderReport" class="flex p-2 justify-content-center">
                        <div class="flex flex-row align-items-center">
                            <p-menu appendTo="body" #billReportMenu [model]="generateBillReportMenuItems(bill)" popup />
                            <i class="cursor-pointer pi pi-file-pdf text-5xl" (click)="billReportMenu.toggle($event)"></i>
                        </div>
                    </div>
                    <div *ngIf="bill && !bill.medicalBillProviderReport" class="flex p-2 justify-content-center">
                        <p-fileUpload mode="basic" 
                            chooseIcon="pi pi-upload" 
                            accept="application/pdf" maxFileSize="10000000" 
                            customUpload
                            (uploadHandler)="uploadBillReport($event,bill)"
                            [auto]="true"/>
                    </div>
                    <div>Bill Report</div>
                </div>
            </div>
            
        </ng-template>
    
    
        <div *ngIf="bill" class="flex flex-row w-full">
            <div class="flex w-10 align-items-center justify-content-start">
                <app-medical-bill-repricer [locked]="encounterLocked" [medicalBill]="bill" [encounterId]="encounter?.id"></app-medical-bill-repricer>
            </div>
            <div class="flex w-2 align-items-center justify-content-end gap-2">
    
                <p-button *ngIf="!encounterLocked" icon="pi pi-pencil" text rounded raised (onClick)="beginEdit(bill,i)"/>
                <p-button *ngIf="!encounterLocked" icon="pi pi-trash" text rounded raised (onClick)="removeMedicalBill(bill)"/>
            </div>
        </div>
        <div *ngIf="!bill">
            Empty
        </div>
    </p-panel>
</div>

<div id="editDiv" #editDiv class="flex flex-column h-auto">
    <div id="editBill" *ngIf="billForEdit && editingMedicalBill" class="flex w-full h-auto">
        <app-medical-bill-editor [medicalBill]="billForEdit" (saved)="billSaved($event)" (cancelled)="editCancelled()"></app-medical-bill-editor>
    </div>

    <div id="newBill" *ngIf="newBillForEdit && editingNewBill" class="flex w-full h-auto">
        <app-medical-bill-editor [medicalBill]="newBillForEdit" (saved)="newBillSaved($event)" (cancelled)="newBillCancelled()"></app-medical-bill-editor>
    </div>
</div>
